import React, { FC, useEffect, useState } from 'react';
import {
  Container,
  CountDownText,
  RecordTimeCounterWrapper,
  RecordDot,
  RecordTimeText,
} from './Counter.styles';
import { RECORD_TIME_LIMIT } from '../RecordVideoComponent';

interface Props {
  initialValue: number;
  setIsCountStarted: (isStarted: boolean) => void;
  startRecording: () => void;
  isCountDownStarted: boolean;
  isRecording: boolean;
}

export const Counter: FC<Props> = ({
  initialValue,
  setIsCountStarted,
  startRecording,
  isCountDownStarted,
  isRecording,
}) => {
  const [count, setCount] = useState(initialValue);
  const [recordingTimeCount, setRecordingTimeCount] = useState(RECORD_TIME_LIMIT);

  useEffect(() => {
    if (isCountDownStarted) {
      let initialCount = count;
      const interval = setInterval(() => {
        if (initialCount === 1) {
          setIsCountStarted(false);
          startRecording();
          clearInterval(interval);
          return;
        }
        initialCount--;
        setCount(initialCount);
      }, 1000);
    }
  }, [isCountDownStarted]);

  useEffect(() => {
    if (isRecording) {
      let initialCount = RECORD_TIME_LIMIT;
      const interval = setInterval(() => {
        if (initialCount === 0) {
          clearInterval(interval);
          return;
        }
        initialCount--;
        setRecordingTimeCount(initialCount);
      }, 1000);
    }
  }, [isRecording]);

  const minutes = Math.floor(recordingTimeCount / 60);
  const seconds = recordingTimeCount % 60;

  return (
    <Container>
      {isCountDownStarted && <CountDownText>{count}</CountDownText>}

      {isRecording && recordingTimeCount > 0 && (
        <RecordTimeCounterWrapper>
          <RecordDot />
          <RecordTimeText>{`${minutes ? minutes + 'm:' : ''}${seconds}s`}</RecordTimeText>
        </RecordTimeCounterWrapper>
      )}
    </Container>
  );
};
